module.exports = __webpack_public_path__ + "static/img/RAWP_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAWP_1.png
// module id = o0sl
// module chunks = 0